import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { PaginationState } from '@shared/models/pagination-state';
import { ToastService } from '@shared/services/toast.service';
import {
  loadNextSteps,
  loadNextStepsFailure,
  loadNextStepsSuccess,
} from '@features/next-steps/actions/load-next-steps.actions';
import { NextStepsApiService } from '@core/services/next-steps-api.service';
import { NextStep } from '@shared/models/next-step';
import { SessionService } from '@shared/services/session.service';

@Injectable()
export class LoadNextStepsEffects {
  constructor(
    private actions$: Actions,
    private nextStepsApiService: NextStepsApiService,
    private toastService: ToastService,
    private sessionService: SessionService,
  ) {}

  loadNextSteps$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadNextSteps),
      withLatestFrom(this.sessionService.getSession()),
      switchMap(([action, session]) => {
        return this.nextStepsApiService.index(action.paginationState, action.filters, action.sorting).pipe(
          map((response: { data: NextStep[]; meta: PaginationState }) => {
            return loadNextStepsSuccess({
              nextSteps: response.data.map((step) => ({
                ...step,
                attributes: { ...step.attributes, owner_id: session?.id },
              })),
              paginationState: response.meta,
            });
          }),
          catchError((error) => {
            return of(loadNextStepsFailure({ error }));
          }),
        );
      }),
    );
  });

  loadNextStepsFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(loadNextStepsFailure),
        tap(() => {
          return this.toastService.showToast('error', 'Unable to load next steps.', 10000);
        }),
      );
    },
    { dispatch: false },
  );
}
